import styled from 'styled-components'
import Colors from '../../../../themes/Colors'

const AdsToolbarHolder = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 0px 0px;

  .left,
  .right {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .left {
    flex: 1;

    .ant-input-search {
      max-width: 320px;
    }
  }

  .filters-button.active {
    border-color: ${Colors.primaryAccent};
    color: ${Colors.primaryAccent};
  }
`

export default AdsToolbarHolder
